import { useRef } from 'react';
import styles from './ExpectationsModal.scss';
import lodash from 'lodash';
import Modal from 'components/common/Modal/Modal';
import { Button, BUTTON } from 'components/common/Button/Button';
import { Link } from 'react-router';

const { SIZE, COLOR, BGCOLOR } = BUTTON;

export const ExpectationsModal = (props) => {
    const {
        binderId,
        documentTypes,
        modalDetails,
        onClose,
        onFile,
        onDelete,
        open
    } = props;

    const uploadedDocumentId = lodash.get(modalDetails, 'uploadedDocument.id', undefined);
    const documentTypeId = lodash.get(modalDetails, 'documentTypeId', undefined);
    const fileType = lodash.get(modalDetails, 'fileType', undefined);
    const modalType = useRef('expectationIssueModal');
    const closeModal = true;

    return (
        <Modal
            onClose={onClose}
            open={open}
            ref={modalType}
            data-cy="ExpectationsModal"
        >
            <div className={styles.modal__body}
                data-cy="ExpectationsModal-div"
            >
                {modalDuplicateErrorContent({ binderId, documentTypes, modalDetails })}
            </div>

            <div className={styles.modal__actions}
            >
                <Button
                    text={'Continue Filing'}
                    className={styles.modal__button__left}
                    type={SIZE.SECONDARY}
                    color={COLOR.RED}
                    onClick={() => onFile(uploadedDocumentId, fileType, documentTypeId, closeModal)}
                    data-cy="ExpectationsModal-Continue"
                />
                <Button
                    text={'Delete Document'}
                    type={SIZE.SECONDARY}
                    bgcolor={BGCOLOR.ORANGE}
                    color={COLOR.WHITE}
                    onClick={() => onDelete(uploadedDocumentId, fileType, documentTypeId)}
                    data-cy="ExpectationsModal-Delete"
                />
            </div>
        </Modal>
    );
};

const modalDuplicateErrorContent = ({ binderId, documentTypes, modalDetails }) => {
    const duplicateDocuments = lodash.get(modalDetails, 'uploadedDocument.duplicates', []);
    const hasViewPermission = duplicateDocuments.find(doc => getPermission(doc, documentTypes));

    return (
        <div className={styles.modal__group} data-cy="ExpectationsModal-modalDuplicateErrorContent">
            <h2 className={styles.modal__title}>
                {'Duplicate Document'}
            </h2>
            <p className={styles.modal__description}>
                {'This document is already filed in this binder. We recommend deleting this unfiled copy.'}
                {hasViewPermission && ' Click the filed documents below to view their contents.'}
            </p>
            {duplicateDocuments.map((duplicateDocument, index) => {
                const path = `/binder/${binderId}/files/${duplicateDocument.documentId}`;
                const userHasDocumentTypePermission = getPermission(duplicateDocument, documentTypes);

                if (userHasDocumentTypePermission) {
                    return (
                        <div className={styles.modal__duplicate__file}
                            data-cy={'ExpectationsModal-' + index}
                            key={index}>
                            <Link
                                className={styles.link}
                                to={path}
                                target={'_blank'}
                            >
                                <i className={styles.icon} />
                                <p className={styles.modal__duplicate__file__name} data-cy={'ExpectationsModal-documentName-' + index}>
                                    {duplicateDocument.documentName}
                                </p>
                                <i className={styles.launchIcon} />
                            </Link>
                        </div>
                    );
                }
            })}
        </div>
    );
};

const getPermission = (objDocument, documentTypes) => {
    return lodash.get(documentTypes, `${objDocument.documentTypeId}.permissions.viewPDF`, false);
};
